import React, { useEffect, useState } from 'react';
import { DisplayText, Dropdown, Tippy } from '@superops/ui-design-system';
import { getCellValue } from '@nile/reports/src/modules/EfficiencyReport/util';
import { isEmpty } from 'lodash';
import { getTranslatedText } from '@nile/components';
import { useIntl } from 'react-intl';

// THIS COMPONENT IS USED TO RENDER
// Select custom field
// Multi Select custom field

const CustomSelectField = (props) => {
  const {
    field,
    value,
    onChange,
    isDisabled,
    isMulti,
    noPortalTarget,
    customLabelComponent,
    ticket,
    fields
  } = props;
  const { fieldType, label } = field;

  const intl = useIntl();
  const [currentValue, setCurrentValue] = useState(null);

  const dataTocheck = { ...ticket, ...ticket?.customFields, ...fields };
  const parentValue =
    getCellValue(dataTocheck, field?.parentField?.columnName) || null;

  const CustomLabelComponent = customLabelComponent;

  useEffect(() => {
    if (value && value.length > 0) {
      if (isMulti) {
        const updateValue = value.map((val) => ({
          label: val,
          value: val
        }));
        setCurrentValue(updateValue);
      } else {
        const updateValue = {
          label: value,
          value: value
        };
        setCurrentValue(updateValue);
      }
    }
  }, [value]);

  const currentValueByRef = React.useRef(null);
  currentValueByRef.current = currentValue;

  const getOptions = () => {
    let fldOptions = field?.options || field?.fieldOptions;
    if (!isEmpty(field?.parentField)) {
      const prntValue =
        typeof parentValue === 'object'
          ? parentValue?.name || parentValue?.id
          : parentValue;
      if (prntValue) {
        fldOptions = fldOptions?.filter(
          (el) => el?.parentOption?.value === prntValue
        );
      } else {
        fldOptions = [];
      }
    }

    const opts = fldOptions?.map((option) => ({
      value: option?.value,
      label: option?.value
    }));
    return opts;
  };

  const options = getOptions();
  const updateValue = (val) => {
    setCurrentValue(val);
    if (onChange && typeof onChange === 'function') {
      onChange(field, val);
    }
  };
  useEffect(() => {
    if (field?.parentField) {
      setCurrentValue(null);
    }
  }, [parentValue]);

  return (
    <>
      <div className="fields-wrapper closure-dropdown">
        {CustomLabelComponent ? (
          <CustomLabelComponent label={label} />
        ) : (
          <DisplayText size="extraLarge" weight="Medium" className="label">
            {label}
          </DisplayText>
        )}
        <Tippy
          title={
            field?.parentField?.columnName
              ? `${getTranslatedText(intl, 'common.admin.dependent.to')} ${
                  field?.parentField?.label
                }`
              : undefined
          }
          position="bottom-end"
          delay={500}
        >
          <div className="custom-field-input">
            <Dropdown
              value={currentValue}
              options={options}
              onChange={updateValue}
              isMulti={isMulti}
              isDisabled={field?.parentField?.columnName && !parentValue}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 99999
                }),
                menu: (provided, state) => ({
                  ...provided,
                  zIndex: 99999,
                  padding: '0 8px'
                }),
                option: (styles, { isSelected }) => ({
                  ...styles,
                  backgroundColor: isSelected
                    ? '#242425'
                    : styles?.backgroundColor,
                  borderRadius: '5px',
                  cursor: 'pointer'
                }),
                valueContainer: (styles) => ({
                  ...styles,
                  cursor: 'pointer'
                })
              }}
              menuPortalTarget={noPortalTarget ? null : document.body}
            />
          </div>
        </Tippy>
      </div>
    </>
  );
};

export default CustomSelectField;
